import React, { useState } from 'react'

import { Radio } from '@thanx/uikit/radio'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'

import noIcon from 'assets/images/points/img_noIcon.svg'
import Input from 'components/Form/Input'
import { I18n } from 'react-redux-i18n'

type Props = {
  currency: string
  limitEnabled: boolean
  maxPointsPerTransaction: number | null
  onChange: (limitPoints: boolean, maxPoints: number | null) => void
  currencyIcon?: string
}

const t = buildTranslate('points.restrictions.points_cap.modal')

const MaximumPoints: React.FC<Props> = ({
  currency,
  limitEnabled,
  maxPointsPerTransaction,
  onChange,
  currencyIcon,
}) => {
  const [isLimitChecked, setLimitChecked] = useState(limitEnabled)
  const [maxPointsValue, setMaxPointsValue] = useState(
    maxPointsPerTransaction || null
  )

  const changeState = (newIsLimitChecked, newMaxPoints) => {
    setLimitChecked(newIsLimitChecked)
    setMaxPointsValue(newMaxPoints)

    onChange(newIsLimitChecked, newMaxPoints)
  }

  return (
    <div
      className="border-1 grey-30-border border-radius-5 p-m"
      data-testid="restriction-section"
    >
      <Text.Header4 className="mt-0 mb-m">
        Maximum {currency} per purchase
      </Text.Header4>
      <div className="d-flex flex-column">
        <Radio
          className="mb-0"
          onClick={() => changeState(false, null)}
          overrides={{
            Root: {
              style: {
                alignItems: 'flex-start',
              },
            },
          }}
          value={'doNotLimit'}
          checked={!isLimitChecked}
        >
          <Text.BodyText3 color="grey70" className="mb-xs" tag="div">
            {t('do_not_limit', { currency })}
          </Text.BodyText3>
        </Radio>
        <Radio
          className="mb-0"
          onClick={() => changeState(true, maxPointsValue)}
          overrides={{
            Root: {
              style: {
                alignItems: 'flex-start',
              },
            },
          }}
          value={'doLimit'}
          checked={isLimitChecked}
        >
          <Text.BodyText3 color="grey70" className="mb-xs" tag="div">
            {t('do_limit', { currency })}
          </Text.BodyText3>
          <Text.BodyText4 color="grey70">
            {t('limit_subtitle', { currency })}
          </Text.BodyText4>
          {isLimitChecked && (
            <div className="py-m">
              <div className="mb-xs">
                <Text.BodyText4 bold>
                  {t('maximum.title', { currency })}
                </Text.BodyText4>
                <Input
                  name="restrict_maximum"
                  value={maxPointsValue || ''}
                  onChange={event =>
                    changeState(true, Number(event.currentTarget.value))
                  }
                  placeholder={t('maximum.placeholder')}
                  addOnBefore={
                    <img
                      height="16px"
                      src={currencyIcon || noIcon}
                      alt={currency}
                      style={{ marginRight: '4px' }}
                    />
                  }
                  validations={{
                    isRequired: true,
                    isNumeric: true,
                    greaterThanOrEqual: 1,
                  }}
                  validationErrors={{
                    isRequired: I18n.t('validations.is_required'),
                    isNumeric: I18n.t('validations.is_numeric'),
                    greaterThanOrEqual: I18n.t('validations.greater_than', {
                      value: 0,
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </Radio>
      </div>
    </div>
  )
}

export default MaximumPoints
